export const LIST_TASKS = 'LIST_TASKS';
export const LIST_TASKS_SUCCESS = 'LIST_TASKS_SUCCESS';
export const LIST_TASKS_FAILURE = 'LIST_TASKS_FAILURE';
export const CREATE_TASKS = 'CREATE_TASKS';
export const CREATE_TASKS_SUCCESS = 'CREATE_TASKS_SUCCESS';
export const CREATE_TASKS_FAILURE = 'CREATE_TASKS_FAILURE';
export const EDIT_TASKS = 'EDIT_TASKS';
export const EDIT_TASKS_SUCCESS = 'EDIT_TASKS_SUCCESS';
export const EDIT_TASKS_FAILURE = 'EDIT_TASKS_FAILURE';
export const DELETE_TASKS = 'DELETE_TASKS';
export const DELETE_TASKS_SUCCESS = 'DELETE_TASKS_SUCCESS';
export const DELETE_TASKS_FAILURE = 'DELETE_TASKS_FAILURE';
export const SHOW_TASK = 'SHOW_TASK';
export const SHOW_TASK_SUCCESS = 'SHOW_TASK_SUCCESS';
export const SHOW_TASK_FAILURE = 'SHOW_TASK_FAILURE';
export const HANDLE_TASK_TITLE = 'HANDLE_TASK_TITLE';
export const SET_TASK_DEFAULTS = 'SET_TASK_DEFAULTS';
export const LIST_ALL_TASKS = 'LIST_ALL_TASKS';